// @ts-nocheck
import React from 'react';
import Loader from 'crehana-ui/Loader';
import Loadable from 'Jsx/Shared/Loadable';

const OfflineLazy = props => (
  <Loadable
    data-testid="ebanx-offline-loadable"
    module={() =>
      import(
        /* webpackChunkName: "checkout-ebanx-argentina-offline" */ './EbanxOffline'
      )
    }
    Loader={
      <div
        className="flex justify-center w-full"
        data-testid="ebanx-offline-loader"
      >
        <Loader size={36} />
      </div>
    }
    {...props}
  />
);

export default OfflineLazy;
